<div class="grid">
  <div class="col-12 sm:col-6">
    <div class="card flex flex-column">
      <div class="flex justify-content-between align-items-center">
        <div class="card-header pt-1">
          <h4 class="mb-1">{{'misc.overview.alarmStatus' | transloco}}</h4>
        </div>
      </div>
      <hr>
      <div>
        <app-generic-graph *ngIf="this.areAlarmChartsLoaded" [data]="alarmStatus"
          [categories]="this.alarmStatusCategories" [name]="'attribute.value' | transloco" [height]="185" [legend]="true"
          [customSeries]="true" chartType="pie"
          dataType="category" [plotOptions]="{pie: {dataLabels: {enabled: false}, showInLegend: true}}"
          [pointFormat]="this.pointFormatPieChart">
        </app-generic-graph>
        <div *ngIf="!this.areAlarmChartsLoaded" [ngStyle]="{width: '185px'}" class="m-auto">
          <p-skeleton shape="circle" height="185px"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12 sm:col-6">
    <div class="card flex flex-column">
      <div class="flex justify-content-between align-items-center">
        <div class="card-header pt-1">
          <h4 class="mb-1">{{'misc.overview.alarmDistribution' | transloco}}</h4>
        </div>
      </div>
      <hr>
      <div>
        <app-generic-graph *ngIf="this.areAlarmChartsLoaded" [data]="alarmDistribution"
          [categories]="this.alarmDistributionCategories" [name]="'attribute.value' | transloco" [height]="185"
          [legend]="true" [customSeries]="true" chartType="pie"
          [plotOptions]="{pie: {dataLabels: {enabled: false}, showInLegend: true}}"
          [pointFormat]="this.pointFormatPieChart" dataType="category">
        </app-generic-graph>
        <div *ngIf="!this.areAlarmChartsLoaded" [ngStyle]="{width: '185px'}" class="m-auto">
          <p-skeleton shape="circle" height="185px"></p-skeleton>
        </div>
      </div>
    </div>
  </div>

  <div class="col-12">
    <div class="card flex flex-column" style="height: 100%;">
      <div class="card-header pt-1">
        <div class="flex w-full align-items-center justify-content-between">
          <div class="inline mb-1">
            <h4 class="mt-1 inline">{{'misc.overview.alarmTable' | transloco}}</h4>
          </div>
          <div>
            <button pButton label=" {{'common.filters' | transloco}}" class="p-button-secondary" icon="pi pi-sliders-h"
              (click)="filtersVisible = !filtersVisible"></button>
          </div>
        </div>

      </div>
      <hr>
      <div class="p-datatable p-component p-datatable-hoverable-rows">
        <p-table [value]="alarms" [lazy]="true" [responsive]="true" (onLazyLoad)="onPageChange($event)"
          [paginator]="true" [(rows)]="rows" [totalRecords]="totalAlarms" styleClass="p-datatable-striped"
          [rowsPerPageOptions]="[10,25,50]" [(first)]="first" breakpoint="1250px">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col">
                {{'attribute.name' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.status' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.serialNumber' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.condition' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.timer' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.activationDate' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.deactivationDate' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.groups' | transloco}}
              </th>
              <th scope="col">
                {{'attribute.organization' | transloco}}
              </th>
              <th scope="col" *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ALARMS')" style="width: 10rem;">
                {{'common.resetAlarm' | transloco}}
              </th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-alarm>
            <tr *ngIf="!areAlarmsLoading">
              <td>
                <span class="p-column-title bold">{{'attribute.name' | transloco}}</span>
                {{alarm.alarmDefinitionName}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.status' | transloco}}</span>
                <p-tag *ngIf="alarm.deactivationDate == null" value="{{'attribute.statusActive' | transloco}}"
                  class="primary-tag state-tag list-tag"></p-tag>
                <p-tag *ngIf="alarm.deactivationDate != null" value="{{'attribute.statusInactive' | transloco}}"
                  class="gray-tag state-tag list-tag"></p-tag>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.serialNumber' | transloco}}</span>
                {{alarm.machine.serial}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.condition' | transloco}}</span>
                {{this.operationsTranslation[alarm.operation]}} ({{ alarm.value}})
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.timer' | transloco}}</span>
                {{alarm.timeWindow}}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.activationDate' | transloco}}</span>
                {{alarm.activationDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.deactivationDate' | transloco}}</span>
                {{alarm.deactivationDate | date:'medium': authGuard.getOffset(): authGuard.getLanguage() }}
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.group' | transloco}}</span>
                <div *ngIf="alarm.groups?.length > 0" class="flex flex-wrap"
                  [ngStyle]="{'gap': '0.5rem', 'max-width': '30rem'}">
                  <p-tag *ngFor="let group of alarm.groups;let i=index" value="{{group.name}}" class="group-tag"
                    [style]="{'background': group.color, 'color': adjustTextColor(group.color)}">
                  </p-tag>
                </div>
              </td>
              <td>
                <span class="p-column-title bold">{{'attribute.organization' | transloco}}</span>
                <div [ngStyle]="{'max-width': '12rem'}" class="overflow-hidden white-space-nowrap text-overflow-ellipsis"
                pTooltip="{{alarm.organization?.name}} ({{alarm.organization?.orgCode}})" tooltipPosition="top">
                  {{alarm.organization?.name}} ({{alarm.organization?.orgCode}})
                </div>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ALARMS')">
                <div *ngIf="!alarm.deactivationDate">
                  <button class="p-button-rounded btn-primary-light mr-2" icon="pi pi-power-off" pButton
                    [pRowToggler]="alarm" (click)="this.deactivateAlarm(alarm.alarmUuid)">
                  </button>
                </div>
              </td>
            </tr>
            <tr *ngIf="areAlarmsLoading">
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td class="row-height">
                <p-skeleton height="1em"></p-skeleton>
              </td>
              <td *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ALARMS')" class="row-height w-10rem">
                <p-skeleton height="1em"></p-skeleton>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="summary">
            <div class="flex align-items-center justify-content-between" *ngIf="alarms.length == 0">{{'pagination.empty'
              | transloco}}</div>
            <div class="flex align-items-center justify-content-between" *ngIf="totalAlarms > 0">
              {{'pagination.showing' | transloco}} {{first + 1}}
              {{'pagination.to' | transloco}} {{(first + rows) >= totalAlarms ? totalAlarms : (first + rows)}}
              {{'pagination.of' | transloco}} {{totalAlarms}}
              {{(totalAlarms > 1 ? 'pagination.entries' : 'pagination.entry') | transloco}}
            </div>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <p-sidebar [(visible)]="filtersVisible" position="right" [baseZIndex]="10000" [style]="{'width':'25em'}">
    <h2 style="margin-left: 10px">{{'common.filters' | transloco}}</h2>
    <div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="name">{{'attribute.name' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input appAutoFocus [focus]="filtersVisible" class="w-full" id="name" type="text" pInputText
            [(ngModel)]="currentFilters.alarmDefinitionName" (keyup.enter)="filtersVisible = false; applyFilters()">
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label>{{'misc.status' | transloco}}</label>
        </div>
        <div class="col-12">
          <div class="p-field-radiobutton margin-top">
            <p-radioButton name="active" label="{{'misc.activeInactive' | transloco}}" [value]="null"
                           [(ngModel)]="currentFilters.active">
            </p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton name="active" label="{{'misc.activeOnly(f)' | transloco}}" [value]="true"
                           [(ngModel)]="currentFilters.active">
            </p-radioButton>
          </div>
          <div class="p-field-radiobutton margin-top">
            <p-radioButton name="active" label="{{'misc.inactiveOnly(f)' | transloco}}" [value]="false"
                           [(ngModel)]="currentFilters.active"></p-radioButton>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="activationDate">{{'attribute.activationDate' | transloco}}</label>
        </div>
        <div class="col-12">
          <p-calendar id="activationDate" [ngModel]="activationDate" [firstDayOfWeek]="1"
            (ngModelChange)="this.activationDate = $event; this.setDate('activationDate', $event)" [showTime]="true"
            dateFormat="dd/mm/yy" [placeholder]="'select.dateTime' | transloco" readonlyInput="true" [hideOnDateTimeSelect]="false"
            appendTo="body" styleClass="w-full" [monthNavigator]="true" [yearNavigator]="true" [showIcon]="true"
            [yearRange]="availableYearRange">
          </p-calendar>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="deactivationDate">{{'attribute.deactivationDate' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-calendar id="deactivationDate" [ngModel]="deactivationDate" [firstDayOfWeek]="1"
            (ngModelChange)="this.deactivationDate = $event; this.setDate('deactivationDate', $event)" [showTime]="true"
            dateFormat="dd/mm/yy" [placeholder]="'select.dateTime' | transloco" readonlyInput="true" [hideOnDateTimeSelect]="false"
            appendTo="body" styleClass="w-full" [monthNavigator]="true" [yearNavigator]="true" [showIcon]="true"
            [yearRange]="availableYearRange">
          </p-calendar>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="serialNumber">{{'attribute.serialNumber' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <input [(ngModel)]="currentFilters.machineSerialNumber" (keyup.enter)="filtersVisible = false; applyFilters()"
                 pInputText class="w-full" id="serialNumber" type="text">
        </div>
      </div>
      <div *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_ADVANCED_MACHINES')" class="col-12">
        <div class="col-12 form-field">
          <label for="group">{{'attribute.group' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-multiSelect [(ngModel)]="currentFilters.machineGroupsUuids" [placeholder]="'select.generic' | transloco"
            [filter]="true" filterBy="name" display="chip" styleClass="w-full" appendTo="body" [options]="machineGroups"
            id="group" optionLabel="name" optionValue="machineGroupUuid">
            <ng-template let-group pTemplate="item">
              <div class="flex align-items-center">
                <p-tag value="{{group.name}}" class="group-tag"
                  [style]="{'background': group.color, 'color': adjustTextColor(group.color)}"></p-tag>
              </div>
            </ng-template>
          </p-multiSelect>
        </div>
      </div>
      <div class="col-12">
        <div class="col-12 form-field">
          <label for="organization">{{'model.organization' | transloco}}</label>
        </div>
        <div class="col-12 form-field">
          <p-treeSelect [(ngModel)]="organizations" [placeholder]="'select.generic' | transloco"
            [propagateSelectionUp]="false" [propagateSelectionDown]="false" display="chip" appendTo="body"
            [options]="hierarchy" [metaKeySelection]="false" selectionMode="checkbox" id="organization">
          </p-treeSelect>
        </div>
      </div>
      <div class="col-12">
        <p-button type="button" (onClick)="filtersVisible = false; applyFilters()"
          label="{{'common.filter' | transloco}}" styleClass="p-button-primary mx-2 mt-2" [disabled]="!(currentFilters.alarmDefinitionName ||
          currentFilters.machineSerialNumber ||
          currentFilters.activationDate ||
          currentFilters.deactivationDate ||
          currentFilters.machineGroupsUuids ||
          currentFilters.active != null ||
          organizations)">
        </p-button>
        <p-button type="button" (click)="resetFilters(); filtersVisible = false; applyFilters()"
          label="{{'common.clear' | transloco}}" styleClass="p-button-danger"></p-button>
      </div>
    </div>
  </p-sidebar>
</div>
